<template>
  <ul class="navbar-nav" v-if="menuItems.length">
    <li
      v-for="item in menuItems"
      :key="item.groupId"
      :class="['nav-item', item.groupSlug === 'meat' ? 'dropdown' : '', { active: isActive(item.groupSlug) }]"
    >
      <template v-if="item.groupSlug === 'meat'">
        <a
          class="nav-link dropdown-toggle"
          href="/products/meat"
          data-bs-toggle="dropdown"
          role="button"
          aria-expanded="false"
        >
          <span class="nav-link-title">{{ item.groupName }}</span>
        </a>
        <div class="dropdown-menu">
          <a class="dropdown-item" :class="{ active: isActive('meat') && !$route.query.type }" href="/products/meat">All meat</a>
          <a
            v-for="t in meatItems"
            :key="t.typeId || t.typeSlug"
            class="dropdown-item"
            :class="{ active: isTypeActive(t.typeSlug) }"
            :href="'/products/meat?type=' + encodeURIComponent(t.typeSlug)"
          >
            {{ t.typeName }}
          </a>
        </div>
      </template>
      <template v-else>
        <a class="nav-link" :href="'/products/' + item.groupSlug">
          <span class="nav-link-title">{{ item.groupName }}</span>
        </a>
      </template>
    </li>
  </ul>
</template>

<script>
import api from "@/services/api"

// When every group is hidden (or none loaded) the template renders no list at all, so BasePage's
// .menu-col is :empty and the phone menu drops the divider above FAQ / My Order.
/** groups.showInMenu: 0 (or "0"/false) hides the group from the top navigation; absent means shown. */
function isShownInMenu(group) {
  const flag = group && group.showInMenu;
  return !(flag === 0 || flag === '0' || flag === false);
}

export default {
  name: "MenuItems",
  data() {
    return {
      menuItems: [],
      currentItem: null,
      isMeat: false,
      meatItems: []
    }
  },
  computed: {
    currentParam() {
      return this.$route.query.type;
    }
  },
  methods: {
    isActive(path) {
      if (path === "/" && this.$route.path.length > 1) {
        return false;
      }
      return path === this.$route.params.groupId
    },
    isTypeActive(param) {
      return param === this.currentParam
    },
    setParam(value) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          type: value
        }
      });
    },
    async loadMeatItems() {
      try {
        if (!this.meatItems.length) {
          this.meatItems = (await api.get('/api/types/group/meat')).data.filter(m => m.typeSlug !== 'game')
        }
      } catch (e) {
        // ignore
      }
    },
    ensureDefaultMeatType() {
      if (this.isMeat && !this.currentParam && this.meatItems.length) {
        this.setParam(this.meatItems[0].typeSlug)
      }
    },
    syncRouteState() {
      this.currentItem = this.$route.params.groupId
      this.isMeat = this.currentItem === 'meat' && !this.$route.params.productId
    }
  },
  async mounted() {
    try {
      // WP-38 (L-80): staff can hide a group from this bar (groups.showInMenu = 0). Its page, products
      // and links stay; only the menu entry, and the Meat types dropdown inside it, go. A group
      // without the field (database not migrated yet) counts as shown.
      const groups = (await api.get('/api/groups')).data;
      this.menuItems = Array.isArray(groups) ? groups.filter(isShownInMenu) : [];
    } catch (e) {
      // ignore
    }
    this.syncRouteState()
    await this.loadMeatItems()
    this.ensureDefaultMeatType()
  },
  watch: {
    $route: {
      immediate: false,
      handler() {
        this.syncRouteState()
        this.loadMeatItems().then(() => {
          this.ensureDefaultMeatType()
        })
      }
    }
  }
}
</script>